<template>
  <div class="toolbox" v-if="admin_value == 0">
    <el-tabs v-model="activeName" @tab-click="handleClick" >
      <el-tab-pane v-for="(item,index) in tabsList" :key="index" :label="item.label" :name="item.id">
      </el-tab-pane>
    </el-tabs>
    <div v-if="activeName == 1">
      <operationLog></operationLog>
    </div>
    <div v-if="activeName == 2">
      <taskLog></taskLog>
    </div>
    <div v-if="activeName == 3">
      <driver_detial></driver_detial>
    </div>
    <div v-if="activeName == 4">
      <chatLog></chatLog>
    </div>
  </div>
</template>

<script>
import operationLog from "@/view/toolBox/operationLog";
import taskLog from "@/view/toolBox/taskLog";
import driver_detial from "@/view/toolBox/driverDetial";
import chatLog from "@/view/toolBox/chatLog";
export default {
  name: "toolBox",
  components:{
    operationLog,taskLog,driver_detial,chatLog
  },
  data(){
    return{
      activeName:'1',
      tabsList:[
        {label:'操作日志',id:'1'},
        {label:'任务日志',id:'2'},
        {label:'司机详情',id:'3'},
        {label:'司机聊天记录查询',id:'4'},
      ],
      admin_value:''
    }
  },
  created() {
    //判断当前账户是否为admin 不是的话不显示
    this.admin_value = JSON.parse(localStorage.getItem('userInfo')).type
  },
  methods:{
    handleClick(){

    }
  }
}
</script>

<style scoped lang="less">

</style>
